// 前端 build 元信息:由 scripts/gen-build-info.mjs 在 vite build 前写入
// src/common/buildInfo.generated.json,这里直接 import。
// 后端 build 元信息通过 /api/build-info 拉,详见 src/apis/build.ts。
import generated from './buildInfo.generated.json';

export interface BuildInfo {
  component: string;
  version: string;
  branch: string;
  commit: string;
  commitShort: string;
  commitTime: string;
  commitSubject: string;
  buildTime: string;
  builtBy: string;
}

export const frontendBuildInfo: BuildInfo = generated as BuildInfo;
